export const isArrayWithLength = (arr) => {
  return  Array.isArray(arr) && !!arr.length;
};

export const isObjectWithKeys = (obj) => {
  return  !!obj && !!Object.keys(obj).length;
};